import { queryPredicateByKey } from '@api/query-client';
import { QueryClient } from '@tanstack/react-query';

/**
 * Invalidates all notificationsGetList queries.
 */
export const invalidateNotificationsGetListQuery = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    predicate: queryPredicateByKey('notificationsGetList')
  });
